/*! Yetkili Servisler — filter / combobox / metaobject pagination
 * Isolated from theme.js — do not merge into theme bundle.
 */
(function () {
  var container = document.getElementById('custom-filter-content');
  if (!container) return;

  var bayiInput = document.getElementById('ys-bayi-search');
  var countEl = document.getElementById('ys-count-num');
  var emptyEl = document.getElementById('ys-empty');
  var resetBtn = document.getElementById('ys-reset');

  function trNormalize(s) {
    return String(s || '')
      .replace(/İ/g, 'i').replace(/I/g, 'i')
      .replace(/ı/g, 'i').replace(/Ş/g, 's').replace(/ş/g, 's')
      .replace(/Ğ/g, 'g').replace(/ğ/g, 'g').replace(/Ü/g, 'u').replace(/ü/g, 'u')
      .replace(/Ö/g, 'o').replace(/ö/g, 'o').replace(/Ç/g, 'c').replace(/ç/g, 'c')
      .toLowerCase();
  }

  // İstanbul Anadolu / Avrupa yaka eşlemesi (ilce normalize edilmiş halde)
  var ISTANBUL_ANADOLU_DISTRICTS = [
    'kadikoy', 'atasehir', 'beykoz', 'cekmekoy', 'umraniye', 'uskudar',
    'kartal', 'maltepe', 'pendik', 'sancaktepe', 'sultanbeyli', 'sile',
    'tuzla', 'adalar', 'bostanci', 'ihlamirkuyu', 'ihlamurkuyu'
  ];
  var ISTANBUL_AVRUPA_DISTRICTS = [
    'arnavutkoy', 'avcilar', 'bagcilar', 'bahcelievler', 'bakirkoy',
    'basaksehir', 'bayrampasa', 'besiktas', 'beyoglu', 'beylikduzu',
    'buyukcekmece', 'catalca', 'esenler', 'esenyurt', 'eyup', 'eyupsultan',
    'fatih', 'gaziosmanpasa', 'gop', 'gungoren', 'kagithane', 'kucukcekmece',
    'k.cekmece', 'kcekmece', 'sariyer', 'silivri', 'sultangazi', 'sisli',
    'zeytinburnu', 'halkali', 'sefakoy'
  ];
  function istanbulSideOfIlce(ilce) {
    var n = trNormalize(ilce);
    if (!n) return null;
    if (ISTANBUL_ANADOLU_DISTRICTS.indexOf(n) >= 0) return 'anadolu';
    if (ISTANBUL_AVRUPA_DISTRICTS.indexOf(n) >= 0) return 'avrupa';
    return null;
  }

  // İl adındaki "(Anadolu)" / "(Avrupa)" eki normalize edilmiş halde
  function istanbulSideFromIl(il) {
    var n = trNormalize(il);
    if (n.indexOf('anadolu') >= 0) return 'anadolu';
    if (n.indexOf('avrupa') >= 0) return 'avrupa';
    return null;
  }

  // Aynı bayi metaobjectte birden fazla kez girilmiş olabilir;
  // data-dedupe / data-uid üzerinden ilk girişi bırakıp diğerlerini kaldır.
  function dedupeCards() {
    var seen = Object.create(null);
    var dupCount = 0;
    container.querySelectorAll('.dists').forEach(function (el) {
      var key = (el.getAttribute('data-dedupe') || '').trim();
      if (!key) {
        key = [
          el.getAttribute('data-il') || '',
          el.getAttribute('data-ilce') || '',
          el.getAttribute('data-search') || ''
        ].join('|').toLowerCase();
      }
      if (seen[key]) {
        el.parentNode && el.parentNode.removeChild(el);
        dupCount++;
      } else {
        seen[key] = true;
      }
    });
    return dupCount;
  }

  /* ===== Custom Combobox ===== */
  function Combobox(rootEl, opts) {
    this.root = rootEl;
    this.input = rootEl.querySelector('.ys-combo__input');
    this.panel = rootEl.querySelector('.ys-combo__panel');
    this.clearBtn = rootEl.querySelector('.ys-filter__clear');
    this.caret = rootEl.querySelector('.ys-combo__caret');
    this.opts = opts || {};
    this.items = [];
    this.value = '';
    this.bind();
  }

  Combobox.prototype.setItems = function (items) {
    this.items = items.slice();
    this.render(this.input.value);
  };

  Combobox.prototype.setDisabled = function (disabled, placeholder) {
    this.input.disabled = disabled;
    this.root.classList.toggle('is-disabled', disabled);
    if (placeholder) this.input.placeholder = placeholder;
    if (disabled) this.close();
  };

  Combobox.prototype.setValue = function (val, opts) {
    opts = opts || {};
    this.value = val || '';
    this.input.value = this.value;
    this.toggleClear();
    if (!opts.silent && typeof this.opts.onChange === 'function') {
      this.opts.onChange(this.value);
    }
  };

  Combobox.prototype.toggleClear = function () {
    if (this.clearBtn) this.clearBtn.classList.toggle('show', !!this.input.value);
  };

  Combobox.prototype.render = function (filterText) {
    var q = trNormalize(filterText || '');
    var html = '';
    var matches = this.items.filter(function (it) {
      if (!q) return true;
      return trNormalize(it).indexOf(q) >= 0;
    });
    if (matches.length === 0) {
      html = '<li class="ys-combo__empty">Eşleşen sonuç yok</li>';
    } else {
      for (var i = 0; i < matches.length; i++) {
        var v = matches[i];
        var safe = v.replace(/&/g, '&amp;').replace(/"/g, '&quot;')
                    .replace(/</g, '&lt;').replace(/>/g, '&gt;');
        html += '<li class="ys-combo__option" role="option" data-value="' + safe + '">' + safe + '</li>';
      }
    }
    this.panel.innerHTML = html;
  };

  Combobox.prototype.open = function () {
    if (this.input.disabled) return;
    this.render(this.input.value);
    this.root.classList.add('is-open');
  };

  Combobox.prototype.close = function () {
    this.root.classList.remove('is-open');
  };

  Combobox.prototype.bind = function () {
    var self = this;

    this.input.addEventListener('focus', function () { self.open(); });
    this.input.addEventListener('click', function () { self.open(); });

    this.input.addEventListener('input', function () {
      self.toggleClear();
      self.render(self.input.value);
      self.root.classList.add('is-open');
      if (typeof self.opts.onType === 'function') self.opts.onType(self.input.value);
    });

    this.input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { self.close(); self.input.blur(); }
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = self.panel.querySelector('.ys-combo__option');
        if (first) {
          var v = first.getAttribute('data-value');
          self.setValue(v);
          self.close();
        }
      }
    });

    this.caret.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (self.root.classList.contains('is-open')) self.close();
      else { self.input.focus(); self.open(); }
    });

    this.panel.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.ys-combo__option');
      if (!li) return;
      e.preventDefault();
      var v = li.getAttribute('data-value');
      self.setValue(v);
      self.close();
    });

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.setValue('');
        self.close();
        self.input.focus();
      });
    }

    document.addEventListener('mousedown', function (e) {
      if (!self.root.contains(e.target)) self.close();
    });
  };

  /* ===== State ===== */
  var ilCombo, ilceCombo;
  var sehirIlceMap = {};
  var currentIstanbulSide = null; // 'anadolu' | 'avrupa' | null

  function buildSehirIlceMap() {
    sehirIlceMap = {};
    container.querySelectorAll('.dists').forEach(function (el) {
      var s = (el.getAttribute('data-il') || '').trim();
      var i = (el.getAttribute('data-ilce') || '').trim();
      if (!s) return;
      if (!sehirIlceMap[s]) sehirIlceMap[s] = {};
      if (i) sehirIlceMap[s][i] = true;
    });
    window.__yetkiliSehirIlceMap = sehirIlceMap;
  }

  function ilList() {
    var keys = Object.keys(sehirIlceMap);
    var hasPlainIstanbul = false;
    var hasAnadoluKey = false;
    var hasAvrupaKey = false;
    keys.forEach(function (k) {
      var n = trNormalize(k);
      if (n === 'istanbul') hasPlainIstanbul = true;
      if (n.indexOf('istanbul') >= 0 && n.indexOf('anadolu') >= 0) hasAnadoluKey = true;
      if (n.indexOf('istanbul') >= 0 && n.indexOf('avrupa') >= 0) hasAvrupaKey = true;
    });
    // Dropdown'da İstanbul'u Anadolu/Avrupa olarak ayrı görmek için sentetik
    // seçenekleri ekle (metaobjectte zaten ayrılmamışsa). Filtreleme tarafı il
    // adındaki "Anadolu"/"Avrupa" ekini ve ilçe yaka eşlemesini otomatik kullanır.
    if (hasPlainIstanbul && !hasAnadoluKey) keys.push('İstanbul (Anadolu)');
    if (hasPlainIstanbul && !hasAvrupaKey) keys.push('İstanbul (Avrupa)');
    return keys.sort(function (a, b) { return a.localeCompare(b, 'tr'); });
  }

  function ilceList(il) {
    if (!il) return [];
    var resolvedKey = resolveIlKey(il);
    var n = trNormalize(il);
    var side = n.indexOf('anadolu') >= 0 ? 'anadolu' : (n.indexOf('avrupa') >= 0 ? 'avrupa' : null);

    if (resolvedKey && sehirIlceMap[resolvedKey]) {
      var list = Object.keys(sehirIlceMap[resolvedKey]);
      if (side) {
        list = list.filter(function (i) { return istanbulSideOfIlce(i) === side; });
      }
      return list.sort(function (a, b) { return a.localeCompare(b, 'tr'); });
    }

    // Sentetik İstanbul (Anadolu/Avrupa): metaobjectte plain "İstanbul" var,
    // dropdown sentetik ayrı seçenek gösteriyor. İlçe listesini plain İstanbul'dan
    // ilgili yakanın ilçelerini filtreleyerek üret.
    if (side && n.indexOf('istanbul') >= 0) {
      var keys = Object.keys(sehirIlceMap);
      for (var i = 0; i < keys.length; i++) {
        if (trNormalize(keys[i]) === 'istanbul') {
          return Object.keys(sehirIlceMap[keys[i]])
            .filter(function (ilce) { return istanbulSideOfIlce(ilce) === side; })
            .sort(function (a, b) { return a.localeCompare(b, 'tr'); });
        }
      }
    }
    return [];
  }

  // sehirIlceMap içinde normalize edilmiş eşleşeni bul (Turkish I/İ/ı farkı + NFC/NFD farkı için).
  function resolveIlKey(input) {
    if (!input) return '';
    if (sehirIlceMap[input]) return input;
    var target = trNormalize(input);
    var keys = Object.keys(sehirIlceMap);
    for (var i = 0; i < keys.length; i++) {
      if (trNormalize(keys[i]) === target) return keys[i];
    }
    return '';
  }

  // ilCombo değerine göre ilçe combobox'ını uygun şekilde aktive et / doldur.
  function syncIlceCombo(il) {
    var n = trNormalize(il || '');
    var resolvedKey = resolveIlKey(il);
    var hasDirect = !!(resolvedKey && sehirIlceMap[resolvedKey]);
    var hasSynthetic = n.indexOf('istanbul') >= 0 && (n.indexOf('anadolu') >= 0 || n.indexOf('avrupa') >= 0);
    if (hasDirect || hasSynthetic) {
      ilceCombo.setItems(ilceList(il));
      ilceCombo.setDisabled(false, 'İlçe seçin veya yazın…');
    } else {
      ilceCombo.setItems([]);
      ilceCombo.setDisabled(true, 'Önce il seçin…');
    }
  }

  function applyFilters() {
    var il = (ilCombo.value || '').trim();
    var ilce = (ilceCombo.value || '').trim();
    var bayi = trNormalize(bayiInput.value);

    var ilNorm = trNormalize(il);
    var ilceNorm = trNormalize(ilce);

    // İstanbul yaka filtresi: il adı veya map seçimi yakayı belirtir.
    var sideFilter = null;
    if (ilNorm.indexOf('istanbul') >= 0) {
      if (ilNorm.indexOf('anadolu') >= 0) sideFilter = 'anadolu';
      else if (ilNorm.indexOf('avrupa') >= 0) sideFilter = 'avrupa';
      else if (currentIstanbulSide) sideFilter = currentIstanbulSide;
    }

    // İl filtresi için normalize edilmiş substring kullanılır; böylece
    // I/İ/i/ı farkı, NFC/NFD farkı ve "İstanbul" vs "İstanbul (Anadolu)" gibi
    // varyasyonlar otomatik eşleşir. Yaka aktifse ek olarak yaka kontrolü yapılır.
    var ilQuery = sideFilter ? 'istanbul' : ilNorm;

    var shown = 0;
    container.querySelectorAll('.dists').forEach(function (card) {
      var cardIl = (card.getAttribute('data-il') || '');
      var cardIlce = (card.getAttribute('data-ilce') || '');
      var cardIlNorm = trNormalize(cardIl);
      var cardIlceNorm = trNormalize(cardIlce);

      var cardSearchNorm = card.__ysSearchNorm;
      if (cardSearchNorm == null) {
        cardSearchNorm = trNormalize(card.getAttribute('data-search') || '');
        card.__ysSearchNorm = cardSearchNorm;
      }

      var matchIl = !il || cardIlNorm.indexOf(ilQuery) >= 0;
      var matchIlce = !ilce || cardIlceNorm === ilceNorm || cardIlceNorm.indexOf(ilceNorm) >= 0;
      var matchBayi = !bayi || cardSearchNorm.indexOf(bayi) >= 0;

      var matchSide = true;
      if (sideFilter) {
        // Yaka bilgisi: önce kartın data-il'inden ("İstanbul (Anadolu)" gibi),
        // bulunamazsa ilçesinden tahmin. Bilinemeyen ilçeler yanlış yakaya
        // düşmemesi için filtre dışında bırakılır.
        var sideFromIl = istanbulSideFromIl(cardIl);
        var sideFromIlce = istanbulSideOfIlce(cardIlce);
        var cardSide = sideFromIl || sideFromIlce;
        matchSide = cardSide === sideFilter;
      }

      if (matchIl && matchIlce && matchBayi && matchSide) {
        card.classList.remove('d-none');
        shown++;
      } else {
        card.classList.add('d-none');
      }
    });

    countEl.textContent = shown;
    emptyEl.hidden = shown > 0;
    var hasFilter = !!(il || ilce || bayi || sideFilter);
    resetBtn.hidden = !hasFilter;
  }

  function onIlChange(val) {
    // İl adında "Anadolu" / "Avrupa" varsa yaka filtresi otomatik aktif olur;
    // yoksa elle seçimde yaka filtresini temizle.
    var n = trNormalize(val);
    if (n.indexOf('istanbul') >= 0 && n.indexOf('anadolu') >= 0) {
      currentIstanbulSide = 'anadolu';
    } else if (n.indexOf('istanbul') >= 0 && n.indexOf('avrupa') >= 0) {
      currentIstanbulSide = 'avrupa';
    } else {
      currentIstanbulSide = null;
    }

    syncIlceCombo(val);
    ilceCombo.setValue('', { silent: true });
    applyFilters();

    if (window.jQuery) {
      var $p = jQuery('#province');
      if ($p.length) $p.val(val);
    }
    if (typeof window.yetkiliServislerSetSeciliIl === 'function') {
      window.yetkiliServislerSetSeciliIl(val);
    }
    if (typeof window.yetkiliServislerSetSelectedPath === 'function') {
      // Haritada Anadolu/Avrupa için ayrı path olduğunda data-iladi tam adı.
      window.yetkiliServislerSetSelectedPath(val);
    }
  }

  function applyBadgeTurkishCase() {
    container.querySelectorAll('.ys-card__badge').forEach(function (el) {
      var label = el.getAttribute('data-ys-label');
      if (label == null) {
        label = el.textContent;
        el.setAttribute('data-ys-label', label);
      }
      el.textContent = String(label).toLocaleUpperCase('tr-TR');
    });
  }

  function init() {
    applyBadgeTurkishCase();
    dedupeCards();
    buildSehirIlceMap();
    var ilEl = document.getElementById('ys-il-combo');
    var ilceEl = document.getElementById('ys-ilce-combo');

    if (!ilCombo) {
      ilCombo = new Combobox(ilEl, { onChange: onIlChange });
      ilceCombo = new Combobox(ilceEl, { onChange: function () { applyFilters(); } });
    }

    ilCombo.setItems(ilList());

    var total = container.querySelectorAll('.dists').length;
    countEl.textContent = total;
    container.querySelectorAll('.dists').forEach(function (c) { c.classList.remove('d-none'); });
  }

  init();

  bayiInput.addEventListener('input', function () {
    var clr = document.querySelector('[data-clear="bayi"]');
    if (clr) clr.classList.toggle('show', !!bayiInput.value);
    applyFilters();
  });
  var bayiClear = document.querySelector('[data-clear="bayi"]');
  if (bayiClear) {
    bayiClear.addEventListener('click', function (e) {
      e.preventDefault();
      bayiInput.value = '';
      bayiClear.classList.remove('show');
      applyFilters();
      bayiInput.focus();
    });
  }

  resetBtn.addEventListener('click', function () {
    currentIstanbulSide = null;
    ilCombo.setValue('', { silent: true });
    ilceCombo.setValue('', { silent: true });
    ilceCombo.setItems([]);
    ilceCombo.setDisabled(true, 'Önce il seçin…');
    bayiInput.value = '';
    var bc = document.querySelector('[data-clear="bayi"]');
    if (bc) bc.classList.remove('show');
    if (typeof window.yetkiliServislerSetSelectedPath === 'function') window.yetkiliServislerSetSelectedPath('');
    if (typeof window.yetkiliServislerSetSeciliIl === 'function') window.yetkiliServislerSetSeciliIl('');
    applyFilters();
  });

  /* ===== Harita köprüsü ===== */
  // İkinci argüman: 'anadolu' | 'avrupa' | null — yalnızca İstanbul için anlamlı.
  window.yetkiliServislerFilterByIl = function (il, side) {
    currentIstanbulSide = (side === 'anadolu' || side === 'avrupa') ? side : null;

    var targetIl = il || '';
    if (currentIstanbulSide && targetIl) {
      // Harita Anadolu/Avrupa'ya tıkladığında dropdown'a tam "İstanbul (Anadolu)"
      // yazılır: metaobjectte ayrı girilmişse exact eşleşir, sentetik seçenek
      // varsa onunla aynı görünür. Filtre tarafı il adındaki yakayı yakalar.
      var sideLabel = currentIstanbulSide === 'anadolu' ? 'Anadolu' : 'Avrupa';
      var sidedKey = resolveIlKey(targetIl + ' (' + sideLabel + ')');
      targetIl = sidedKey || (targetIl + ' (' + sideLabel + ')');
    } else if (targetIl) {
      var k = resolveIlKey(targetIl);
      if (k) targetIl = k;
    }

    ilCombo.setValue(targetIl, { silent: true });
    syncIlceCombo(targetIl);
    ilceCombo.setValue('', { silent: true });
    applyFilters();
  };
  window.yetkiliServislerFilterByIlce = function (ilce) {
    ilceCombo.setValue(ilce || '', { silent: true });
    applyFilters();
  };
  window.yetkiliServislerSetSearchIl = window.yetkiliServislerFilterByIl;

  /* ===== Eski #province uyumluluğu (contact-form var ise) ===== */
  if (window.jQuery) {
    jQuery(function ($) {
      $(document).off('change.yetkiliMeta', '#province').on('change.yetkiliMeta', '#province', function () {
        var sel = this.value;
        var $ilce = $('#Ilceler');
        $ilce.html('');
        if (!sel) { $ilce.prop('disabled', true); return; }
        $ilce.prop('disabled', false);
        $ilce.append($('<option>', { value: 0, text: 'Lütfen Bir İlçe seçiniz' }));
        ilceList(sel).forEach(function (i) { $ilce.append($('<option>', { value: i, text: i })); });
      });
    });
  }

  /* ===== Multi-page yükle (chain via data-next-url) =====
     Shopify metaobjects paginate URL parametresi `?page_<hash>=N` formatında
     üretiliyor (her paginate scope'una göre hash'i farklı). Bu yüzden manuel
     `?page=N` construct edemeyiz; her sayfanın server-rendered `data-next-url`
     değerini takip ederek zincirleme fetch yaparız. Yeni gelen sayfada da
     data-next-url olur → bir sonraki sayfa → ta ki next-url boş olana kadar. */
  var totalItems = parseInt(container.getAttribute('data-total-items') || '0', 10);

  function dedupeKeyFor(el) {
    return (el.getAttribute('data-dedupe') || el.getAttribute('data-uid') || '').trim();
  }

  function loadNextPage(nextUrl) {
    if (!nextUrl) return Promise.resolve();
    return fetch(nextUrl, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedContainer = doc.getElementById('custom-filter-content');
        if (!fetchedContainer) return;

        var existing = Object.create(null);
        container.querySelectorAll('.dists').forEach(function (c) {
          var k = dedupeKeyFor(c);
          if (k) existing[k] = true;
        });
        fetchedContainer.querySelectorAll('.dists').forEach(function (d) {
          var k = dedupeKeyFor(d);
          if (k && existing[k]) return;
          if (k) existing[k] = true;
          container.appendChild(d);
        });

        var furtherNext = fetchedContainer.getAttribute('data-next-url') || '';
        if (furtherNext) {
          container.setAttribute('data-next-url', furtherNext);
          return loadNextPage(furtherNext);
        } else {
          container.setAttribute('data-next-url', '');
        }
      })
      .catch(function (err) { console.warn('[yetkili-servis] sonraki sayfa fetch hata:', err); });
  }

  var nextUrl = container.getAttribute('data-next-url') || '';
  if (nextUrl) {
    loadNextPage(nextUrl).then(function () {
      container.setAttribute('data-source', 'metaobject-merged');
      init();
      applyFilters();
      var rendered = container.querySelectorAll('.dists').length;
      if (totalItems && rendered < totalItems) {
        console.warn('[yetkili-servis] eksik render: ' + rendered + '/' + totalItems);
      }
      document.dispatchEvent(new CustomEvent('yetkili-servis:loaded', {
        detail: { totalItems: rendered, expected: totalItems }
      }));
    });
  } else {
    document.dispatchEvent(new CustomEvent('yetkili-servis:loaded', {
      detail: { totalItems: container.querySelectorAll('.dists').length, expected: totalItems }
    }));
  }
})();
